export default "__VITE_ASSET__k$hVU3MG__"